"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Popconfirm = exports.IconButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _Icon = _interopRequireDefault(require("../Icon"));

var _Button = require("./Button.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * 按鈕組件
 */
var Button = function Button(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "orange" : _ref$variant,
      size = _ref.size,
      children = _ref.children,
      disabled = _ref.disabled,
      loading = _ref.loading,
      mr = _ref.mr,
      onClick = _ref.onClick,
      _ref$full = _ref.full,
      full = _ref$full === void 0 ? true : _ref$full,
      textColor = _ref.textColor;
  return /*#__PURE__*/_react.default.createElement(_Button.UiButton, {
    variant: variant,
    block: true,
    size: size,
    onClick: onClick,
    disabled: disabled,
    loading: loading,
    mr: mr,
    full: full ? 1 : 0,
    style: textColor ? {
      color: textColor
    } : {}
  }, children);
};

var IconButton = function IconButton(_ref2) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? "orange" : _ref2$variant,
      size = _ref2.size,
      children = _ref2.children,
      disabled = _ref2.disabled,
      loading = _ref2.loading,
      mr = _ref2.mr,
      onClick = _ref2.onClick,
      _ref2$full = _ref2.full,
      full = _ref2$full === void 0 ? true : _ref2$full,
      _ref2$iconName = _ref2.iconName,
      iconName = _ref2$iconName === void 0 ? "close" : _ref2$iconName,
      icon = _ref2.icon,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? "default" : _ref2$type,
      textColor = _ref2.textColor;
  return /*#__PURE__*/_react.default.createElement(_Button.UiButton, {
    variant: variant,
    block: true,
    size: size,
    onClick: onClick,
    disabled: disabled,
    loading: loading,
    mr: mr,
    full: full ? 1 : 0,
    style: textColor ? {
      color: textColor
    } : {}
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, icon ? icon : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: iconName,
    type: type
  })), children);
};

exports.IconButton = IconButton;

var Popconfirm = function Popconfirm(_ref3) {
  var _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? "" : _ref3$title,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? "orange" : _ref3$variant,
      size = _ref3.size,
      children = _ref3.children,
      disabled = _ref3.disabled,
      loading = _ref3.loading,
      _ref3$full = _ref3.full,
      full = _ref3$full === void 0 ? true : _ref3$full,
      mr = _ref3.mr,
      _ref3$onConfirm = _ref3.onConfirm,
      onConfirm = _ref3$onConfirm === void 0 ? function () {} : _ref3$onConfirm;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      deletePopup = _useState2[0],
      setDeletePopup = _useState2[1];

  var onConfirmHandle = function onConfirmHandle() {
    setDeletePopup(false);
    onConfirm();
  };

  return /*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
    title: title,
    visible: deletePopup,
    onConfirm: onConfirmHandle,
    onCancel: function onCancel() {
      return setDeletePopup(false);
    },
    okText: "\u78BA\u5B9A",
    cancelText: "\u53D6\u6D88"
  }, /*#__PURE__*/_react.default.createElement(Button, {
    variant: variant,
    block: true,
    size: size,
    onClick: function onClick() {
      return setDeletePopup(true);
    },
    disabled: disabled,
    loading: loading,
    mr: mr,
    full: full
  }, children));
};

exports.Popconfirm = Popconfirm;
var _default = Button;
exports.default = _default;
Button.propTypes = {
  variant: _propTypes.default.string,
  size: _propTypes.default.string,
  children: _propTypes.default.node,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  mr: _propTypes.default.number,
  full: _propTypes.default.bool,
  textColor: _propTypes.default.string
};
IconButton.propTypes = {
  variant: _propTypes.default.string,
  size: _propTypes.default.string,
  children: _propTypes.default.node,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  mr: _propTypes.default.number,
  full: _propTypes.default.bool,
  iconName: _propTypes.default.string,
  type: _propTypes.default.string,
  icon: _propTypes.default.node,
  textColor: _propTypes.default.string
};
Popconfirm.propTypes = {
  title: _propTypes.default.string,
  variant: _propTypes.default.string,
  size: _propTypes.default.string,
  children: _propTypes.default.node,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  full: _propTypes.default.bool,
  visible: _propTypes.default.bool,
  mr: _propTypes.default.number,
  onConfirm: _propTypes.default.func
};